import React from 'react'

type Props = {
    video:any;
}
const VideoColumn: React.FC<Props> = ({
  video
}) => (
  <tr>
    <td>{video.col1} </td>
    <td>{video.col2} </td>
    <td>{video.col3} </td>
    <td>{video.col4} </td>
    <td>{video.col5} </td>
    <td>{video.col6} </td>
    <td>{video.col7} </td>
  </tr>
)

export default VideoColumn
